import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { fetchScheduleSuccess, fetchScheduleFailed } from '../actions';
import { ScheduleEmailReportTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchSchedule({ data }) {
  const url = `${API_BASE_URL}/report-settings?page=${data.page}&size=${data.size}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchScheduleSuccess(response.raw));
  } else {
    
    networkErrorHandler(response?.statusCode, `Failed to Fetch Reminder: ${response.message}`);
    yield put(fetchScheduleFailed(response.message));
  }
}

export function* getEmailReportScheduleSettings() {
  yield takeEvery(ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS, fetchSchedule);
}